import { useEffect, useMemo } from 'react';
import { Calendar } from 'jamespot-front-business';
import socket from '../utils/socket';
import { useAppDispatch } from '../redux/store';
import jApi from 'jamespot-user-api';

const useCalendarRT = () => {
    const dispatch = useAppDispatch();
    const reactSocket = useMemo(() => socket, []);
    const rtHandlers = useMemo(() => Calendar.getCalendarRTHandlers(dispatch, jApi), [dispatch]);

    useEffect(() => {
        rtHandlers.forEach((handler) => {
            reactSocket.onMessage(handler.namespace, handler.function, handler.handler);
        });
        return () => {
            rtHandlers.forEach((handler) => {
                reactSocket.offMessage(handler.namespace, handler.function, handler.handler);
            });
        };
    }, [rtHandlers, reactSocket]);
};

export default useCalendarRT;
